import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'reactstrap';

import BlogQueryHeader from 'Components/Blog/content/BlogQueryHeader';
import BlogPostsCard from 'Components/Blog/cards/BlogPostsCard';

export default function BlogPosts({ posts, totalResultsSize, authorSlug, category }) {
  return (
    <div>
      <BlogQueryHeader authorSlug={authorSlug} category={category} />
      {isEmpty(posts) && totalResultsSize > 0 &&
        <div className="d-flex flex-column align-items-center mt-5">
          <FontAwesomeIcon icon={faMagnifyingGlass} />
          <h3 className="pt-3">
            <FormattedMessage id="blogposts.results.help" defaultMessage="We couldn't find any results for you." />
          </h3>
          <p>
            <FormattedMessage
              id="blogposts.search-terms"
              defaultMessage="Try adjusting the terms of your search"
            />
          </p>
        </div>
      }
      {!isEmpty(posts) && <Row>
        {posts.map(post =>
          <Col xs={12} md={6} key={post.id}>
            <BlogPostsCard showLabel post={post} blogCardNameTag="h2" />
          </Col>,
        )}
      </Row>}
    </div>
  );
}

BlogPosts.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object),
  totalResultsSize: PropTypes.number,
  authorSlug: PropTypes.string,
  category: PropTypes.string,
};

BlogPosts.defaultProps = {
  posts: [],
  totalResultsSize: 0,
  authorSlug: '',
  category: '',
};
